<template>
  <div>
    <div>
      <SectionHeader :text="$t('history.clothing')" />
      <transition name="load">
        <h2 v-if="!data" class="text-center">
          <Loading />
        </h2>
        <div v-if="data" id="history-content">
          <div class="header-spacer"></div>
          <div class="vestimenation-wrapper">
            <div
              class="w-col w-col-6 image"
              v-for="item in data"
              :key="item.text"
            >
              <img :src="item.thumbnail" />
              <div class="text">{{ item.text }}</div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import Loading from "../Loading";
import SectionHeader from "../SectionHeader";

export default {
  name: "FirstPage",
  components: {
    Loading,
    SectionHeader
  },
  data() {
    return {
      data: null
    };
  },
  mounted() {
    this.$http
      .get("vestimentation/")
      .then(response => (this.data = response.data));
  }
};
</script>

<style scoped>
.load-enter-active,
.load-leave-active {
  transition: 1s;
}

.load-leave-active {
  position: absolute;
}

.load-enter {
  opacity: 0;
}

.load-leave-to {
  opacity: 0;
}

.vestimenation-wrapper .w-col {
  margin-top: 10px;
  margin-bottom: 10px;
}

.text {
  background-color: white;
  font-size: 1em;
  line-height: 1.3em;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  padding: 0 50px;
  height: calc(5 * 1.3em);
  display: flex;
  justify-content: center;
  align-items: center;
}

.image {
  cursor: pointer;
}

.image:hover .text {
  background-color: black;
  color: white;
}
</style>

<style></style>
